import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Text } from '@shared/components'
import { Flex, Form, RadioChangeEvent, RadioGroupProps } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { useHealthInsuranceValues } from './HealthInsuranceContext'
import { INSURED_AFTER_DAYS } from './utils'

const RadioGroup = ({ onChange, ...props }: RadioGroupProps) => {
  const { t } = useTranslation()
  const formInstance = Form.useFormInstance()

  const handleChange = (event: RadioChangeEvent) => {
    const value = event.target.value
    if (typeof value !== 'boolean') return

    formInstance.setFieldValue(
      'insurance_after_count_days',
      value ? 0 : INSURED_AFTER_DAYS
    )

    const validFrom = formInstance.getFieldValue('valid_from') || dayjs()
    const days = formInstance.getFieldValue('count_days') || 0

    if (!value) {
      const isNotValidDate =
        dayjs(validFrom).diff(dayjs(), 'd') + 1 < INSURED_AFTER_DAYS

      const newStartDate = isNotValidDate
        ? dayjs(validFrom).add(INSURED_AFTER_DAYS, 'd').toString()
        : validFrom

      const newEndDate = dayjs(newStartDate)
        .add(days - 1, 'd')
        .toString()

      formInstance.setFieldValue('valid_from', dayjs(newStartDate))
      formInstance.setFieldValue('valid_to', dayjs(newEndDate))
    }
    onChange?.(event)
  }

  return (
    <Flex vertical gap={8}>
      <RadioCardGroup
        {...props}
        options={[
          { value: true, label: t('yes') },
          { value: false, label: t('no') }
        ]}
        onChange={handleChange}
      />

      {!props?.value && (
        <Text>
          {t('insured_is_not_located_in_rm', {
            days: INSURED_AFTER_DAYS
          })}
        </Text>
      )}
    </Flex>
  )
}

export const PeopleAreInCountry = () => {
  const { t } = useTranslation()
  const { isEditable } = useHealthInsuranceValues()
  const { required } = useValidationsField()

  return (
    <Form.Item
      name="in_country"
      label={t('people_are_in_country_question')}
      rules={[required]}
    >
      <RadioGroup disabled={isEditable} />
    </Form.Item>
  )
}
